import { IS_PUBLIC_ALBUM } from 'reactApp/appHelpers/configHelpers';
import { getFeaturePublicAlbumTemporaryUrl } from 'reactApp/modules/features/features.selectors';
import { store } from 'reactApp/store';

/**
 * Временно альбомы открываются по урлу /album/ вместо /publiс/
 * Это сделано для того, что урлы альбомов не открывались через диалинк в приложении
 * до тех пор пока мобилки не поддержат публичные альбомы
 */
export const isPublicAlbumTemporaryUrl = () => {
    if (!IS_PUBLIC_ALBUM) {
        return;
    }
    const isAlbumTemporaryUrlFeatureEnabled = getFeaturePublicAlbumTemporaryUrl(store.getState());
    const isAlbumLocation = location.pathname?.match(/^\/album/);

    return isAlbumTemporaryUrlFeatureEnabled && isAlbumLocation;
};
